import { useEffect } from 'react';
import { useAudioTrackContext } from '../_mediator/audio-track.provider';

export const useWs = () => {
  const { leftOffset } = useAudioTrackContext();
  const { wsRoot } = useAudioTrackContext();

  useEffect(() => {
    leftOffset.current = wsRoot.current!.getBoundingClientRect().left;
  }, []);
};
